/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

// Mapbox Studio sprite names.
// Suffix variants (`-active`, `-disabled`) exist as separate sprites in the
// Mapbox style and are selected at runtime via GeoJSON feature `suffix`.
export const CAMPING_PIN = 'camping-pin';
export const CAMPING_PIN_DISABLED = 'camping-pin-disabled';
export const CAMPING_PIN_ACTIVE = 'camping-pin-active';
export const DAY_USE_PIN = 'day-use-pin';
export const PERMITS_PIN = 'permits-pin';
export const TREE_PERMITS_PIN = 'tree-permit-pin';
export const POI_PIN = 'poi-pin';
export const REC_AREA_PIN = 'rec-area-pin';
export const PASSES_PIN = 'passes-pin';
export const ACTIVITY_PASS_PIN = 'activity-pass-pin';
export const ACTIVITY_PASS_PIN_DISABLED = 'activity-pass-pin-disabled';
export const TICKET_FACILITY_PIN = 'ticket-facility-pin';
export const TOURS_PIN = 'tours-pin';
export const VENUE_WEDDING_PIN = 'venue-wedding-pin';
export const VENUE_SMALL_GATHERING_PIN = 'venue-small-gathering-pin';
export const VENUE_SHOOTING_PIN = 'venue-shooting-pin';
export const VENUE_OTHER_PIN = 'venue-other-pin';
export const VENUE_LARGE_RECEPTION_PIN = 'venue-large-reception-pin';
export const VENUE_HUNTING_PIN = 'venue-hunting-pin';
export const VENUE_GOLFING_PIN = 'venue-golfing-pin';
export const VENUE_ATHLETIC_ACTIVITY_PIN = 'venue-athletic-activity-pin';
export const GATEWAY_PIN = 'gateway-pin';

export const defaultPadding = { top: 88, bottom: 42, left: 42, right: 88 };
export const mobilePadding = { top: 88, bottom: 350, left: 42, right: 88 };

/**
 * Icon-name → circle color pairs used to color circle markers (the sub-zoom
 * variant of pin markers). Consumers that build a Mapbox `match` expression
 * for `circle-color` can iterate this list.
 */
export const circleIconsColors: ReadonlyArray<readonly [string, string]> = [
    [CAMPING_PIN, '#4a77b4'],
    [CAMPING_PIN_DISABLED, '#afbec8'],
    [CAMPING_PIN_ACTIVE, '#c3512c'],
    [DAY_USE_PIN, '#7fb135'],
    [GATEWAY_PIN, '#efaa00'],
    [PERMITS_PIN, '#d27a56'],
    [REC_AREA_PIN, '#efaa00'],
    [POI_PIN, '#5abf95'],
    [TOURS_PIN, '#93348c'],
    [TICKET_FACILITY_PIN, '#93348c'],
    [PASSES_PIN, '#3e4ded'],
    [ACTIVITY_PASS_PIN, '#0D7EA2'],
    [ACTIVITY_PASS_PIN_DISABLED, '#afbec8'],
    [VENUE_WEDDING_PIN, '#731F44'],
    [VENUE_SMALL_GATHERING_PIN, '#731F44'],
    [VENUE_SHOOTING_PIN, '#731F44'],
    [VENUE_OTHER_PIN, '#731F44'],
    [VENUE_LARGE_RECEPTION_PIN, '#731F44'],
    [VENUE_HUNTING_PIN, '#731F44'],
    [VENUE_GOLFING_PIN, '#731F44'],
    [VENUE_ATHLETIC_ACTIVITY_PIN, '#731F44'],
];

/**
 * Icon names that consumers should preload as facility sprite images before
 * adding the symbol layers.
 */
export const facilityIcons: ReadonlyArray<string> = [
    CAMPING_PIN,
    DAY_USE_PIN,
    PERMITS_PIN,
    TREE_PERMITS_PIN,
    POI_PIN,
    REC_AREA_PIN,
    PASSES_PIN,
    ACTIVITY_PASS_PIN,
    TICKET_FACILITY_PIN,
    TOURS_PIN,
    VENUE_WEDDING_PIN,
    VENUE_SMALL_GATHERING_PIN,
    VENUE_SHOOTING_PIN,
    VENUE_OTHER_PIN,
    VENUE_LARGE_RECEPTION_PIN,
    VENUE_HUNTING_PIN,
    VENUE_GOLFING_PIN,
    VENUE_ATHLETIC_ACTIVITY_PIN,
];

export const venuePins: Record<string, string> = {
    'wedding-ceremony': VENUE_WEDDING_PIN,
    'small-gathering': VENUE_SMALL_GATHERING_PIN,
    shooting: VENUE_SHOOTING_PIN,
    other: VENUE_OTHER_PIN,
    'large-reception': VENUE_LARGE_RECEPTION_PIN,
    hunting: VENUE_HUNTING_PIN,
    golfing: VENUE_GOLFING_PIN,
    'athletic-activity': VENUE_ATHLETIC_ACTIVITY_PIN,
};
